<template>
  <div>
    <button @click.stop="open" ref="button" class="dropdown-toggle btn-icon clear-area controllers" :id="`moreActionsButton_${model.client_id}`" type="button">
      <icon class="kebab"></icon>
      <span class="sr-only">More Actions Dropdown</span>
    </button>

    <context-menu ref="contextMenu"
                  :state="modalStateFor(vueModalID.sortableContextMenu)"
                  :index="vueModalID.sortableContextMenu"
                  fixed
                  @close="toggleModal">
      <ul>
        <li v-if="!model.isFirst">
          <button ref="up" @click.stop="move('up')" @keyup.enter="move('up', true)" class="dropdown-item">Move Up</button>
        </li>
        <li v-if="!model.isLast">
          <button ref="down" @click.stop="move('down')" @keyup.enter="move('down', true)" class="dropdown-item">Move Down</button>
        </li>
        <li v-if="model.check_by_default">
          <button @click.stop="uncheckItem" class="dropdown-item">Clear as default</button>
        </li>
        <li>
          <button @click.stop="deleteItem" class="dropdown-item">Delete</button>
        </li>
      </ul>
    </context-menu>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import ContextMenu from "./contextMenu.vue";
  import {ISortable} from "../interfaces/propertyInterfaces";

  export default Vue.extend({
    props: {
      model: {
        type: Object as () => ISortable,
        required: true,
      }
    },
    components: {ContextMenu},
    methods: {
      open(event): void {
        this.showModal(this.vueModalID.sortableContextMenu);
        this.$refs.contextMenu.open(event);
      },
      close(): void {
        this.$refs.contextMenu.close();
      },
      deleteItem(): void {
        this.$emit('remove');
        this.close()
      },
      move(direction: 'up'|'down' = 'down', isKeyboardEvent: boolean = false) {
        switch(direction) {
          case 'up':
            this.model.moveUp();
            break;
          default:
            this.model.moveDown();
        }

        if (isKeyboardEvent) {
          if (direction === 'up' && this.model.isFirst) {
            direction = 'down';
          } else if (direction === 'down' && this.model.isLast) {
            direction = 'up';
          }
          this.$nextTick(() => {
            this.$refs[direction].focus();
            this.$refs.contextMenu.reposition({target: this.$refs.button});
          });
        } else {
          this.close();
        }
      },
      uncheckItem(): void {
        this.model.check_by_default = false;
        this.$emit('unchecked', this.model.client_id);
        this.close();
      }
    }
  });
</script>
